import { isEqual } from 'lodash';

/**
 * Build a PATCH body containing only fields that changed between snapshots.
 *
 * @param {Record<string, unknown>} previous
 * @param {Record<string, unknown>} current
 * @param {{ scalarKeys?: string[], arrayKeys?: string[], objectKeys?: string[] }} options
 */
export function buildChangedPatch(previous, current, { scalarKeys = [], arrayKeys = [], objectKeys = [] } = {}) {
  const patch = {};
  const prev = previous ?? {};
  const next = current ?? {};

  scalarKeys.forEach((key) => {
    if (prev[key] !== next[key]) {
      patch[key] = next[key];
    }
  });

  arrayKeys.forEach((key) => {
    if (!isEqual(prev[key] ?? [], next[key] ?? [])) {
      patch[key] = next[key];
    }
  });

  objectKeys.forEach((key) => {
    if (!isEqual(prev[key], next[key])) {
      patch[key] = next[key];
    }
  });

  return patch;
}

export function areValuesEqual(left, right) {
  return isEqual(left, right);
}
